import { Component, ViewChild, ViewContainerRef } from "@angular/core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FieldWrapper } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./verticalInput.component.html",
})
export class FormlyVerticalInput extends FieldWrapper {
    @ViewChild("fieldComponent", { read: ViewContainerRef })
    declare fieldComponent: ViewContainerRef;
    faInfoSign = faInfoCircle;
}
